// removed by extract-text-webpack-plugin
module.exports = {"table":"CalendarTable__table___3LG0a","owners":"CalendarTable__owners___3sg6J"};